import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  cardWrapper: {
    width: 'calc(100% - 40px)',
    maxWidth: '500px',
    display: 'flex',
    flex: '1 1 350px',
    cursor: 'pointer',
  },
  cardHeading: {
    color: '#141106',
    fontSize: '25px',
    fontWeight: '600',
    textAlign: 'left',
    wordBreak: 'break-word',
    display: '-webkit-box',
    maxWidth: '400px',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  cardIcon: {
    verticalAlign: 'middle',
    padding: '0 5px'
  },
  cardKey: {
    color: '#141106',
    opacity: '0.5',
    width: '50%'
  },
  cardValue: {
    color: '#141106',
    textAlign: 'right',
    textTransform: 'capitalize',
    wordBreak: 'break-word'
  },
  endIcon: {
    position: 'absolute',
    right: '1rem'
  },
  trackButton: {
    border: '1px solid #F37320 ',
    '&:hover': {
      background: '#FFF',
    }
  },
  logoWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  utilityLogo: {
    width: '60px',
    marginRight: '10px'
  },
  multipleLogo: {
    width: '50%',
    marginRight: '10px'
  },
  paperRoot: {
    width: '100%'
  }
}))

export { useStyles }
